# This middleware is responsible for tracking interactions events 
# which are triggered from thomas

trackView = (data, done) ->
  Application.publish("event:view") data

trackInteraction = (data) ->
  Application.publish("event:interaction") data

trackEvent = ->
startTracking = ->
stopTracking = ->

commands = (next) ->
  { trackInteraction, trackView, startTracking, stopTracking, trackEvent }

module.exports = { type: "analytics", commands }

